const getCalendarDates = (month: number, year: number, weekStartsOn: number | undefined): Date[] => {
    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);

    const firstDayOfGrid = new Date(
      firstDayOfMonth.getFullYear(),
      firstDayOfMonth.getMonth(),
      firstDayOfMonth.getDate() -
        ((firstDayOfMonth.getDay() - (weekStartsOn ?? 0) + 7) % 7)
    );

    const totalDaysInGrid =
      Math.ceil(
        (lastDayOfMonth.getDate() +
          ((firstDayOfMonth.getDay() - (weekStartsOn ?? 0) + 7) % 7)) /
          7
      ) * 7;

    const dates: Date[] = new Array(totalDaysInGrid);
    const date = new Date(firstDayOfGrid);

    for (let i = 0; i < totalDaysInGrid; i++) {
      dates[i] = new Date(date);
      date.setDate(date.getDate() + 1);
    }

    return dates;
}

export default getCalendarDates;
